import { GlobalStyles as Styles } from '@mui/material';
import CLASSES from './classes';

const GlobalStyles = () => {
  return <Styles styles={(theme) => CLASSES(theme)} />;
};

export default GlobalStyles;
